import styled, { css } from 'styled-components';

export const HeaderStyled = styled.div<{ fullWidth?: boolean }>`
  ${({ fullWidth }) =>
    fullWidth
      ? css`
          display: flex;
          width: 100%;
        `
      : css`
          display: inline-flex;
        `}
`;
